export function encodeRoleParam(roleName: string) {
  const bytes = new TextEncoder().encode(roleName)
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('')
  return `~${btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, '')}`
}

export function decodeRoleParam(value: string | undefined) {
  if (!value?.startsWith('~')) return value

  try {
    const encoded = value.slice(1).replaceAll('-', '+').replaceAll('_', '/')
    const padded = encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')
    const bytes = Uint8Array.from(atob(padded), (character) =>
      character.charCodeAt(0),
    )
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes)
  } catch {
    return value
  }
}
